import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { erroreHtml: string; messaggi: string[]; titolo?: string },
        public dialogRef: MatDialogRef<ErrorModalComponent>
    ) {
        if (!data.titolo) {
            data.titolo = 'Errore';
        }
    }

    ngOnInit() {}
}
